const Cursor = () => {
    return (
        <div id="cursor"><span></span></div>
    );
}
 
export default Cursor;